var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('a-input-search',{staticStyle:{"width":"300px"},attrs:{"placeholder":_vm.placeholder,"allowClear":true},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }